<template>
  <GridLayout 
    :class="classes" 
    :columns="label.length > 0 ? '40, *' : ''" 
    :role="radio ? 'radio' : 'checkbox'"
    :tabindex="disabled ? -1 : 0"
    :aria-checked="isChecked ? 'true' : 'false'"
    :aria-disabled="disabled ? 'true' : 'false'"
    :aria-label="label || 'Checkbox'"
    :aria-describedby="description ? descriptionId : null"
    @tap="check" 
    @click="check"
    @keydown="handleKeydown"
  >
    <AgIcon 
      col="0" 
      :type="icon" 
      :color="color" 
      size="24" 
      verticalAlignment="top" 
      aria-hidden="true"
    />
    <StackLayout col="1">
      <Label 
        v-if="label.length > 0" 
        class="label" 
        :style="{ color: invalid ? color : null }" 
        :text="label" 
        textWrap 
      />
      <Label 
        v-if="description.length > 0" 
        :id="descriptionId"
        class="description" 
        :text="description" 
        textWrap 
      />
    </StackLayout>
  </GridLayout>
</template>

<script>

import { colors } from '@/helpers/ui'

export default {
  name: 'Checkbox',
  model: {
    prop: 'checked',
    event: 'check'
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    value: {},
    checked: {},
    disabled: {
      type: Boolean,
      default: false
    },
    bold: {
      type: Boolean,
      default: false
    },
    radio: {}
  },
  data() {
    return {
      invalid: false,
      uid: 'checkbox-' + Date.now() + '-' + Math.floor(Math.random() * 10000)
    };
  },
  computed: {
    descriptionId() {
      return `checkbox-desc-${this.uid}`;
    },
    classes () {
      return {
        'checkbox': true,
        'control': true,
        ['type-' + this.type]: true,
        'checked': this.isChecked,
        'disabled': this.disabled,
        'bold': this.bold,
        'invalid': this.invalid,
        'has-description': this.description.length > 0
      }
    },
    icon () {
      if (this.isChecked) {
        return this.type === 'radio' ? 'fas:dotCircle' : 'fas:checkSquare'
      } else {
        return this.type === 'radio' ? 'far:circle' : 'far:square'
      }
    },
    color () {
      if (this.invalid) {
        return colors.error
      }

      return this.isChecked && !this.disabled ? colors.primary : colors.grey
    },
    type () {
      return this.radio === 'true' || this.radio === '' || this.radio === true ? 'radio' : 'default'
    },
    isChecked () {
      if (this.type === 'radio') {
        return this.checked === this.realValue
      } else if (this.checked instanceof Array) {
        return this.checked.indexOf(this.realValue) >= 0
      } else {
        return this.checked
      }
    },
    realValue () {
      return typeof this.value === 'undefined' ? this.label : this.value
    }
  },
  methods: {
    check () {
      if (!this.disabled) {
        if (this.type === 'radio') {
          this.$emit('check', this.realValue)
        } else if (this.checked instanceof Array) {
          const array = this.checked.slice()

          if (this.isChecked) {
            const index = this.checked.indexOf(this.realValue)

            if (index >= 0) {
              array.splice(index, 1)
            }
          } else {
            array.push(this.realValue)
          }

          this.$emit('check', array)
        } else {
          this.$emit('check', !this.isChecked)
        }
      }
    },
    setInvalid (v) {
      this.invalid = v
    },
    handleKeydown(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.check();
      }
    }
  }
}
</script>

<style scoped lang="scss">

.checkbox {
  .label {
    color: #3b3b3b;
  }

  &.bold .label {
    font-weight: 900;
  }
}

.ns-ios,
.ns-android {
  .checkbox {
    &.has-description .label {
      font-size: 20;
    }

    .description {
      margin-top: 10;
    }
  }
}

html {
  .checkbox {
    cursor: pointer;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;

    &.disabled {
      cursor: default;
    }

    &.has-description .label {
      line-height: 30px;
      font-size: 18px;
      font-weight: bold;
    }

    .description {
      margin-top: 10px;
    }
  }
}

</style>
